"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = require("react-router");

var _AdsUtil = require("../../utils/AdsUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeAdsPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HomeAdsPanel, _Component);

  function HomeAdsPanel() {
    (0, _classCallCheck3.default)(this, HomeAdsPanel);
    return (0, _possibleConstructorReturn3.default)(this, (HomeAdsPanel.__proto__ || (0, _getPrototypeOf2.default)(HomeAdsPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeAdsPanel, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "home-notices" },
        this.renderTitle(),
        _react2.default.createElement(
          "div",
          null,
          this.renderAds()
        )
      );
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      if (this.props.adType === "supplierAd") {
        return this.renderTitleWithText("Tarjotaan maa-ainesta", "tarjottavat");
      }
      return this.renderTitleWithText("Vastaanotetaan maa-ainesta", "vastaanotettavat");
    }
  }, {
    key: "renderTitleWithText",
    value: function renderTitleWithText(text, urlSlug) {
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          to: "/ilmoitukset/" + urlSlug,
          className: "home-notices-title title-link-js"
        },
        _react2.default.createElement(
          "h3",
          { className: "h5 home-notices-title-js" },
          _react2.default.createElement(
            "span",
            null,
            text
          )
        )
      );
    }
  }, {
    key: "renderAds",
    value: function renderAds() {
      var _this2 = this;

      return this.props.ads.map(function (ad) {
        var topClassNames = "home-notice-top";
        var bottomClassNames = "home-notice-bottom";
        var linkClassNames = "home-notice home-notice-js";

        if (ad.visibility > 0) {
          topClassNames += " ad-private";
          bottomClassNames += " ad-private";
          linkClassNames += " ad-private";
        }

        if (ad.project_id > 0) {
          //      topClassNames += ' ad-project';
          bottomClassNames += " ad-project";
          linkClassNames += " ad-project";
        }

        return _react2.default.createElement(
          _reactRouter.Link,
          {
            className: linkClassNames,
            key: ad.id,
            to: "/ilmoitukset/" + ad.id
          },
          _react2.default.createElement(
            "div",
            { className: topClassNames },
            _react2.default.createElement(
              "p",
              { className: "soil-type-js" },
              _react2.default.createElement(
                "b",
                null,
                (0, _AdsUtil.getSoilTypeName)(ad, _this2.props.soilTypes),
                " ",
                ad.soil_amount,
                " t"
              )
            ),
            _react2.default.createElement(
              "p",
              null,
              ad.postal_area,
              " ",
              _this2.createDateTime(ad.created_at)
            ),
            _react2.default.createElement("i", { className: "icon-mp-arrow" })
          )
        );
      });
    }
  }, {
    key: "createDateTime",
    value: function createDateTime(timestamp) {
      return (0, _moment2.default)(timestamp).format("D.M.YYYY");
    }
  }]);
  return HomeAdsPanel;
}(_react.Component), _class.propTypes = {
  ads: _react.PropTypes.array.isRequired,
  adType: _react.PropTypes.oneOf(["supplierAd", "receiverAd"]).isRequired,
  soilTypes: _react.PropTypes.array.isRequired
}, _temp);
exports.default = HomeAdsPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ads/HomeAdsPanel.js
 ** module id = 1147
 ** module chunks = 0
 **/